module.exports = __webpack_public_path__ + "static/media/play_arrow.0afc49f2.svg";